var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{staticStyle:{"direction":"rtl"}},[_c('v-img',{attrs:{"src":_vm.cphllogo,"height":"200","contain":""}}),_c('div',{staticClass:"logotext"},[_vm._v(" مختبر الصحة العامة المركزي ")]),_c('div',{staticClass:"logotext2"},[_vm._v(" نظام معلومات غربلة الاطفال حديثي الولادة ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }